import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AbstractDynamicComponent } from '@components/abstracts';
import { ListingCoinRepas } from '@components/listing-coin-repas/models';
import { TranslatePipe } from '@ngx-translate/core';
import { ImageComponent } from '@shared/components/image';
import { TitleComponent } from '@shared/components/title';

@Component({
  selector: 'app-listing-coin-repas',
  imports: [ImageComponent, TranslatePipe, NgClass, TitleComponent],
  templateUrl: './listing-coin-repas.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ListingCoinRepasComponent extends AbstractDynamicComponent<ListingCoinRepas> {}
